import styled from "styled-components"
import {Card} from "@irati/ui/src/Layout"
import {useBranding} from "@irati/brand"
import {useIntl} from "@irati/utils/lang"
import Spacing from "@irati/ui/src/Spacing"
import PrimaryDetails from "../PrimaryDetails"
import StatusType from "@irati/wallet/types/enums/Status"
import React from "react"
import {Wallet} from "@irati/types"

interface Props {
  wallet: Wallet
}
const StyledCard = styled(Card)`
  margin-bottom: 20px;
  box-shadow: 0 4px 11px 0 rgba(82, 97, 115, 0.18);
`

export function NextTopupStatementItem({wallet}: Props) {
  const branding = useBranding()
  const {formatMessage} = useIntl()

  return (
    <Spacing marginBottom={4}>
      <StyledCard medium noborder>
        <PrimaryDetails
          imgHeightAuto
          data={{
            title: formatMessage({id: "wallet.statementItem.topup.primaryDetails.flexiPoints.title"}),
            subTitle: formatMessage({id: "wallet.statementItem.topup.primaryDetails.subTitle"}),
            image: branding?.businessLogoUrl,
            amount: wallet.nextTopup?.amount! / 100,
            currency: wallet.currency,
            status: StatusType.SCHEDULED_TOPUP
          }}
        />
      </StyledCard>
    </Spacing>
  )
}
